var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3945 1.83203L8.6875 8.16016H12.625C13.082 8.16016 13.5039 8.44141 13.6797 8.86328C13.8203 9.32031 13.7148 9.8125 13.3633 10.1289L4.36328 18.0039C3.94141 18.3203 3.37891 18.3555 2.95703 18.0391C2.53516 17.7578 2.35938 17.1953 2.57031 16.7031L5.27734 10.375H1.375C0.882812 10.375 0.460938 10.0938 0.320312 9.67188C0.144531 9.21484 0.25 8.72266 0.601562 8.40625L9.60156 0.53125C10.0234 0.214844 10.5859 0.179688 11.0078 0.496094C11.4297 0.777344 11.6055 1.33984 11.3945 1.83203Z",
    fill: "#38539A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashIcon);
export default __webpack_public_path__ + "static/media/flash_icon.b27e53cacd32806df908a1e4c8431a29.svg";
export { ForwardRef as ReactComponent };